
<!--<div class="w-100 text-end py-1">-->
<!--  <button [routerLink]="createlink" type="button" class="btn btn-sm btn-primary ">-->
<!--    <i class="fas fa-plus mouse-pointer"></i> Add flag-->
<!--  </button>-->
<!--</div>-->

<ng-template #valueTemplate
             let-valueinput="value"
             let-elementinput="element"
             let-columninput="column">
  <ng-container *ngIf="columninput['columnName']==='active'">
    <ng-container *ngIf="valueinput===true">
      <i class="fas fa-circle limegreen"></i>
    </ng-container>
    <ng-container *ngIf="valueinput===false">
      <i class="fas fa-circle red"></i>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="columninput['columnName']!=='active'">
    {{valueinput}}
  </ng-container>
</ng-template>

<app-crud-list [observabledata]="observabledata"
               [displayedColumns]="displayedcolumns"
               [postTreatmentCallback]="getPostTreatmentCallback()"
               [idColumnName]="'id'"
               [entityroot]="entityroot"
               [deleteEntityHandler]="deleteEntityHandler()"
               [removePostTreatmentHandler]="deletePostTreatmentHandler()"
               [listEditPathCallback]="getListEditPathCallback()"
               [specificColumnsTemplates]="[
                        {key: 'active', template:valueTemplate}
                       ]"
>
</app-crud-list>
